/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------ COMPONENTES DE BASE--------------------------
import { formatNumberDecimal } from "../../../../../Base/Services/FormatTemplate";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { getLocalDateString } from "../../../../../Base/Services/FechasService";
import { getDateString } from "../../../../../Base/Services/Moment/Luxon";

// ------------------- CONSULTAS A LA API---------------------------
import { getRequisa } from "../../../../../API/Compras/RequisiscionCompras/PurchaseRequest";
import { getPurchaseSinCancelar } from "../../../../../API/Compras/Requisas/PurchaseRequest";
import { getFirmaPersonal } from "../../../../../API/Payrolls/Firmas/FirmasRequests";
import { getInformacionEmpresa } from "../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { RequisasComprasReporteLang } from "./RequisasComprasLang";

import QRCode from 'qrcode';
import { GenerarBufferPDF } from "../../../../../utils/Funciones/FuncionesGenerales";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const RequisasComprasReporte = ({ IdR, lan,setBuf=() => {} ,onBufferReady =false,show, notOpen =true }) => {

  const { IdReq } = useParams();
  const { Idioma } = useParams();
  const [purchaseDetalle, setPurchaseDetalle] = useState([]);
  const [IdPurchase, setIdPurchase] = useState(0);
  const [idioma, setIdioma] = useState(2);
  const [infoEmpresa, setInfoEmpresa] = useState([]);

  const obtenerInformacion = async (IdReq, Idioma) => {
    const tempoEncabezado = await getRequisa(IdReq);

    const agruparDetalles = (detalles) => {
      const groupedDetails = {};
  
      // Agrupar los detalles por IdProduct y Price
      detalles.forEach(detalle => {
          const { IdProduct, Price, Quantity } = detalle;
          const key = `${IdProduct}-${Price}`;
  
          if (groupedDetails[key]) {
              groupedDetails[key].Quantity += Quantity;
          } else {
              groupedDetails[key] = { ...detalle };
          }
      });

      return Object.values(groupedDetails);
    };

    const tempoDetalles = await getPurchaseSinCancelar(IdReq);
    const detallesAgrupados = agruparDetalles(tempoDetalles);


    const infoEmpresaTempo = await getInformacionEmpresa();
    setInfoEmpresa(infoEmpresaTempo);

    let name = infoEmpresaTempo[0]?.NombreLegal
    let direccion = infoEmpresaTempo[0]?.Direccion
    let logoB64 = infoEmpresaTempo[0]?.LogoPrimarioB64

    let IdLanguage = Number(Idioma);

    let autorizoGerente = null,
      autorizoFinanzas = null,
      autorizoPlantaM = null;
    
    let cantidadFirmas = 0
    let necesitaFirmaGerente;
    let necesitaFinanzas;
    let necesitaBodega;

    const imgBlanca = await getFirmaPersonal('111');

    if (tempoDetalles.length > 0) {
      const algunoDetallesLiberar = tempoDetalles.some(detalle => detalle['Liberar Gerente'] === 1); //TIENE
      const algunoDetallesFinanzas = tempoDetalles.some(detalle => detalle.Finanzas === 1);
      const algunoDetallesPlantManager = tempoDetalles.some(detalle => detalle['Gerente Planta'] === 1);
      
      necesitaFirmaGerente = tempoDetalles.some(detalle => detalle.AutorizaGerente === true); //NECESITA
      if (necesitaFirmaGerente) cantidadFirmas++;

      necesitaFinanzas = tempoDetalles.some(detalle => detalle.Finanzas === true); //NECESITA
      if (necesitaFinanzas) cantidadFirmas++;

      necesitaBodega = tempoDetalles.some(detalle => detalle.Bodega === true); //NECESITA
      if (necesitaFinanzas) cantidadFirmas++;
  
      if (tempoDetalles[0]?.IdPersonalAutorizoGerente) {
        if (algunoDetallesLiberar) {
          autorizoGerente = await getFirmaPersonal(tempoDetalles[0]?.IdPersonalAutorizoGerente);
        }
      }
  
      if (tempoDetalles[0]?.IdPersonalAutorizoFinanzas) {
        if (algunoDetallesFinanzas) {
          autorizoFinanzas = await getFirmaPersonal(tempoDetalles[0]?.IdPersonalAutorizoFinanzas);
        }
      }
  
      if (tempoDetalles[0]?.IdPersonalAutorizoPlantManager) {
        if (algunoDetallesPlantManager) {
          autorizoPlantaM = await getFirmaPersonal(tempoDetalles[0]?.IdPersonalAutorizoPlantManager);
        }
      }
    }

    generarPDF(
      tempoEncabezado[0],
      detallesAgrupados,
      IdLanguage,
      autorizoGerente,
      autorizoFinanzas,
      autorizoPlantaM,
      name,
      direccion,
      logoB64,
      necesitaFirmaGerente,
      necesitaFinanzas,
      cantidadFirmas, 
      imgBlanca,
    );
  };

  useEffect(() => {

    if (IdReq) {
      obtenerInformacion(IdReq, Idioma);
      setIdPurchase(IdReq);
    }
  }, [IdReq, Idioma]);

  useEffect(() => {
    if (show) {
      obtenerInformacion(IdR, lan);
      setIdPurchase(IdR);
      setIdioma(lan);
    }
  }, [show]);

  const obtenerImagenPDF = (img) => {
    if (!img || typeof img !== "string") {
      return null;
    }

    if (img.startsWith("data:image/")) {
      return img;
    }

    return `data:image/png;base64,${img}`;
  };

  const generarPDF = (
    data,
    listadoDetalles,
    Idioma,
    autorizoGerente,
    autorizoFinanzas,
    autorizoPlantaM,
    name, 
    direccion,
    logoB64,
    necesitaFirmaGerente,
    necesitaFinanzas,
    cantidadFirmas,
    imgBlanca

  ) => {

    let Language = Idioma === 1 ? "en" : "es";
    const firmaBlancaPDF = obtenerImagenPDF(imgBlanca);
    const logoPDF = obtenerImagenPDF(logoB64);
    const firmaGerentePDF = obtenerImagenPDF(autorizoGerente);
    const firmaFinanzasPDF = obtenerImagenPDF(autorizoFinanzas);
    const firmaPlantaPDF = obtenerImagenPDF(autorizoPlantaM);


    const UserNameAutorizoGerente = listadoDetalles[0]?.UserNameAutorizoGerente ?? "";
    const UserNameautorizoPlantManager = listadoDetalles[0]?.UserNameAutorizoPlantManager ?? "";
    const UserNameAutorizoFinanzas = listadoDetalles[0]?.UserNameAutorizoFinanzas ?? "";


    let Texturl = null
    QRCode.toDataURL(`${data.PurchaseRequest}`, { errorCorrectionLevel: 'Q' }, (err, url) => {
      Texturl = url;
    })

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [35, 100, 35, 80],

      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            widths: [200, 350, 20],
            columns: [
              [
                {
                image: logoPDF,
                width: 200,
                margin: [4, -10, -10, -10],
              },
              {},
              ],
              [
                {
                  text: name,
                  style: "titulo2",
                  margin: [-10, 30, 0, 0],
                  width: 320,
                },
                {
                  text: direccion,
                  style: "titulo3",
                  margin: [-10, 5, 0, 0],
                  width: 320,
                  fillColor: "#FF0000",
                },


              ],
              [
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "TituloReporte",
                    Language
                  )}\n ${data.PurchaseRequest || ""} `,
                  style: "numeroDoc",
                  margin: [0, 40, 0, 0],
                },
              ]
            ],
          },
        ];
      },

      footer: (currentPage, pageCount) => {
        return {
          table: {
            widths: [150, 300, 150],
            body: [
              [
                {
                  text:
                    `${getLabel(
                      RequisasComprasReporteLang,
                      "fechaImpresion",
                      Language
                    )}` + getLocalDateString(new Date())
                    + "\n\n" +
                    `${getLabel(
                      RequisasComprasReporteLang,
                      "original",
                      Language
                    )}`
                    + "\n\n" +
                    `${getLabel(
                      RequisasComprasReporteLang,
                      "copia",
                      Language
                    )}\n\n`
                  ,
                  // style: "footer",
                  margin: [30, 20, 5, 0],
                  fontSize: 7.5,
                },
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "Pagina",
                    Language
                  )} ${currentPage} / ${pageCount}`,
                  alignment: "center",
                  fontSize: 7.5,
                  margin: [0, 20, 0, 0],
                },
                {
                  image: Texturl,
                  width: 70,
                  margin: [0, 0, 30, 0],
                  alignment: "right",
                },
              ],
            ]
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return (rowIndex % 2 === 0) ? '#FFFFFF' : null;
            },
            defaultBorder: false,
          }
        };
      },

      content: [
        {
          columns: [
            {
              margin: [0, 0, 0, 0],

              table: {
                widths: [250, 20, 250],
                body: [
                  [
                    {
                      text: `${getLabel(
                        RequisasComprasReporteLang,
                        "fechaCreacion",
                        Language
                      )} ${getDateString(new Date(data.DateCreated || ""))}`,
                      border: [false, false, false, false],
                      style: "infoGeneral",
                    },
                    { text: "", border: [false, false, false, false] },
                    { text: ``, border: [false, false, false, false] },
                  ],
                  [
                    {
                      text: `${getLabel(
                        RequisasComprasReporteLang,
                        "area",
                        Language
                      )} ${data.Area || ""}`,
                      border: [false, false, false, false],
                      style: "infoGeneral",
                    },
                    { text: "", border: [false, false, false, false] },
                    {
                      text: `${getLabel(
                        RequisasComprasReporteLang,
                        "creadoPor",
                        Language
                      )} ${data.UserName || ""}`,
                      border: [false, false, false, false],
                      style: "infoGeneral",
                      alignment: "right",
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        RequisasComprasReporteLang,
                        "tipo",
                        Language
                      )} ${data.Type || ""}`,
                      border: [false, false, false, true],
                      style: "infoGeneral",
                    },
                    { text: "", border: [false, false, false, true] },
                    {
                      text: `${getLabel(
                        RequisasComprasReporteLang,
                        "solicitadoPor",
                        Language
                      )} ${data.UserRequest || ""} `,
                      border: [false, false, false, true],
                      style: "infoGeneral",
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
          ],
        },
      ],

      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        titulo: {
          fontSize: 8,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        titulo2: {
          fontSize: 10,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        titulo3: {
          fontSize: 10,
          // margin: [0, 50, 0, 0],
          // bold: true,
          alignment: "justify",
        },
        requisa: {
          fontSize: 15,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        numeroDoc: {
          fontSize: 10,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 8,
          margin: [-5, 0, 0, 0],
          // bold: true,
          // alignment: 'justify'
        },
        infoProveedor: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
        header: {
          fontSize: 6.5,
          alignment: "center",
          bold: true,
        },
        headerr: {
          fontSize: 7,
          alignment: "center",
          // bold: true,
        },
        textBody1: {
          fontSize: 7.5,
          alignment: "center",
          // lineHeight: 2
        },
        textBody2: {
          fontSize: 7,
          alignment: "right",
          // lineHeight: 2
        },
        textBody3: {
          fontSize: 7.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textBody4: {
          fontSize: 8.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textTotales: {
          bold: true,
          fontSize: 7.5,
          alignment: "right",
        },
        textCentrado: {
          fontSize: 7.5,
          alignment: "center",
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
        footer: {
          fontSize: 7.5,
          alignment: "left",
          margin: [30, 0, 5, 0],
        },
      },
    };

    const detallesPorMoneda = {};
    listadoDetalles.forEach((detalle) => {
      const moneda = detalle.CurrencySymbol || detalle.Currency;
      if (!detallesPorMoneda[moneda]) {
        detallesPorMoneda[moneda] = [];
      }
      detallesPorMoneda[moneda].push(detalle);
    });

    // Generar una tabla por cada conjunto de productos que comparten la misma moneda
    const monedasEntries = Object.entries(detallesPorMoneda);
    monedasEntries.forEach(([moneda, detalles], indexMoneda) => {   
      const esUltimaMoneda = indexMoneda === monedasEntries.length - 1;
      const productosMoneda = detalles.map((d) => {
        return [
          { text: d.CodigoProducto, style: "textBody1" },
          { text: d.NombreProducto, style: "textBody3" },
          { text: formatNumberDecimal(d.Quantity), style: "textBody1" },
          { text: d.UnitName, style: "textBody1" },
          { text: formatNumberDecimal(d.Price), style: "textBody2" },
          { text: formatNumberDecimal(d.TAX), style: "textBody2" },
          { text: formatNumberDecimal(d.Discount), style: "textBody2" },
          { text: formatNumberDecimal(d.SubTotal), style: "textBody2" },
          { text: formatNumberDecimal(d.Total), style: "textBody2" },
        ];
      });

      let numberOfRows = 0;
      numberOfRows += productosMoneda.length;
      let numberOfProduct = detalles.reduce((total, detalle) => total + detalle.Quantity, 0);

      const subtotalMoneda = detalles.reduce((total, detalle) => total + detalle.SubTotal, 0);
      const descuentoMoneda = detalles.reduce((total, detalle) => total + detalle.Discount, 0);
      const impuestoMoneda = detalles.reduce( (total, detalle) => total + detalle.TAX, 0);
      const totalMoneda = detalles.reduce((total, detalle) => total + detalle.Total, 0);

      docDefinition.content.push(
        {
          margin: [0, 8, 0, 0],
          text:
            `${getLabel(RequisasComprasReporteLang, "detallesEn", Language)}` +
            `${detalles[0].Currency}`,
          style: "titulo",
        },
        {
          margin: [0, 10, 5, 5],
          table: {
            widths: [45, 142, 32, 30, 32, 32, 32, 32, 40],
            body: [
              [
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "codigo",
                    Language
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "producto",
                    Language
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "cantidad",
                    Language
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "unidad",
                    Language
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "precio",
                    Language
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "isv",
                    Language
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    RequisasComprasReporteLang,
                    "descuento",
                    Language
                  )}`,
                  style: "header",
                },
                { text: `SUBTOTAL`, style: "header" },
                { text: "TOTAL", style: "header" },
              ],
              ...productosMoneda,
            ],
          },
          layout: "lightHorizontalLines",
        },

        {
          margin: [0, 3, 5, 5],
          table: {
            widths: [45, 152, 32, 30, 32, 32, 32, 32, 76],
            body: [
              [
                {
                  text: formatNumberDecimal(`${numberOfRows}`),
                  style: "headerr",
                  border: [false, true, false, false],
                  margin: [-20, 0, 0, 0]
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: formatNumberDecimal(`${numberOfProduct}`),
                  style: "headerr",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },

            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
          },
        },

        {
          margin: [0, 0, 5, 5, 5],
          table: {
            widths: [385, 50, 15, 60],
            body: [
            [
              {
                text: esUltimaMoneda
                  ? `Comentario: ${data.Comment || ""}`
                  : "",
                style: "titulo",
                border: [false, false, false, false],
                rowSpan: 4,
                alignment: "left",
                margin: [0, 8, 20, 0],
              },
              { text: "SubTotal", style: "textTotales" },
              {
                text: `${moneda}`,
                border: [false, true, false, true],
                style: "textTotales",
              },
              {
                text: formatNumberDecimal(subtotalMoneda),
                border: [false, true, true, true],
                style: "textTotales",
              },
            ],

            [
              {},
              {
                text: `${getLabel(
                  RequisasComprasReporteLang,
                  "descuento",
                  Language
                )}`,
                style: "textTotales",
              },
              {
                text: `${moneda}`,
                border: [false, true, false, true],
                style: "textTotales",
              },
              {
                text: formatNumberDecimal(descuentoMoneda),
                style: "textTotales",
                border: [false, true, true, true],
              },
            ],

            [
              {},
              {
                text: `${getLabel(
                  RequisasComprasReporteLang,
                  "isv",
                  Language
                )}`,
                style: "textTotales",
              },
              {
                text: `${moneda}`,
                border: [false, true, false, true],
                style: "textTotales",
              },
              {
                text: formatNumberDecimal(impuestoMoneda),
                style: "textTotales",
                border: [false, true, true, true],
              },
            ],

            [
              {},
              { text: "Total", style: "textTotales" },
              {
                text: `${moneda}`,
                border: [false, true, false, true],
                style: "textTotales",
              },
              {
                text: formatNumberDecimal(totalMoneda),
                style: "textTotales",
                border: [false, true, true, true],
              },
            ],
          ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea vertical
            },
            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
            vLineColor: function (i) {
              return "#aaa"; // Color de las líneas verticales
            },
          },
        }
      );
    });

    // FIRMAS
    cantidadFirmas === 1 ?
    docDefinition.content.push(
      {
        columns: [
          {
            margin: [0, 60, 0, 0],

            table: {
              widths: [150, 20, 150, 20, 150],
              body: [
                [
                  // Firma de autorizoGerente
                  [
                    firmaBlancaPDF
                    ? {
                        image: firmaBlancaPDF,
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      }
                    : {
                        text: "",
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      },

                      necesitaFirmaGerente ?
                    {
                      border: [false, true, false, false],
                      text: `\n  _______________________________________ \n${getLabel( RequisasComprasReporteLang, "autorizadoPor", Language  )}` + "\n" + UserNameAutorizoGerente,
                      style: "firmas",
                      width: [120],
                    } :                     {
                      border: [false, true, false, false],
                      text: '',
                      style: "firmas",
                      width: [120],
                    }
                  ],

                  { text: "" },             
                  // Firma de autorizoFinanzas o espacio en blanco si no tiene firma
                  [
                    { text: "", margin: [-20, 115, -10, -10] },
                    { text: "", margin: [-20, 115, -10, -10] },

                  ],

                  { text: "" },             
                  // Firma de autorizoPlantaM o espacio en blanco si no tiene firma
                  [
                    firmaBlancaPDF
                      ? {
                          image: firmaBlancaPDF,
                          width: 150,
                          height: 130,
                          margin: [0, 0, -50, -30],
                        }
                      : {
                          text: "",
                          width: 150,
                          height: 130,
                          margin: [0, 0, -50, -30],
                        },
                    {
                      border: [false, true, false, false],
                      text:
                        `\n  _______________________________________ \n${getLabel(
                          RequisasComprasReporteLang,
                          "GerentePlanta",
                          Language
                        )}` +
                        "\n" +
                        // listadoDetalles[0]?.UserNameAutorizoPlantManager || "",
                        UserNameautorizoPlantManager,
                      style: "firmas",
                      width: [120],
                    },
                  ],
                ],
              ],
            },
            layout: {
              defaultBorder: false,
            },
          },
        ],
      }
    ):

    cantidadFirmas === 2 ?     
    docDefinition.content.push(
      {
        columns: [
          {
            margin: [0, 0, 0, 0],

            table: {
              widths: [150, 20, 150, 20, 150],
              body: [
                [
                  [
                    autorizoGerente
                      ? {
                        image: firmaGerentePDF || firmaBlancaPDF,
                        width: 150,
                        height: 130,

                        margin: [0, 0, -50, -30],
                      }
                      : {
                        image: "data:image/png;base64," + imgBlanca,
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      },

                      necesitaFirmaGerente ?
                    {
                      border: [false, true, false, false],
                      text: `\n  _______________________________________ \n${getLabel( RequisasComprasReporteLang, "autorizadoPor", Language  )}` + "\n" + UserNameAutorizoGerente,
                      style: "firmas",
                      width: [120],
                    } :                     {
                      border: [false, true, false, false],
                      text: '',
                      style: "firmas",
                      width: [120],
                    }
                  ],

                  { text: "" },
                  [
                    autorizoFinanzas
                      ? {
                        image: firmaFinanzasPDF || firmaBlancaPDF,
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      }
                      : 
                      {
                        image: "data:image/png;base64," + imgBlanca,
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      },
                    {
                      border: [false, true, false, false],
                      text:
                        `\n  _______________________________________ \n${getLabel(
                          RequisasComprasReporteLang,
                          "Finanzas",
                          Language
                        )}` +
                        "\n" +
                        UserNameAutorizoFinanzas,
                      style: "firmas",
                      width: [120],
                    },
                    { text: "", margin: [-20, 115, -10, -10] },

                  ],

                  { text: "" },
                  [
                    autorizoPlantaM
                      ? {
                        image: firmaPlantaPDF || firmaBlancaPDF,
                        width: 150,
                        margin: [0, 0, -50, -30],
                      }
                      : {
                        image: "data:image/png;base64," + imgBlanca,
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      },
                    {
                      border: [false, true, false, false],
                      text:
                        `\n  _______________________________________ \n${getLabel(
                          RequisasComprasReporteLang,
                          "GerentePlanta",
                          Language
                        )}` +
                        "\n" +
                        // listadoDetalles[0]?.UserNameAutorizoPlantManager || "",
                        UserNameautorizoPlantManager,
                      style: "firmas",
                      width: [120],
                    },
                  ],
                ],
              ],
            },
            layout: {
              defaultBorder: false,
            },
          },
        ],
      }
    ):

    docDefinition.content.push(
      {
        columns: [
          {
            margin: [0, 0, 0, 0],

            table: {
              widths: ['*', 150, 20, 150, '*'],
              headerRows: 2,
              body: [
                // [
                //   {
                //     text: `Comentario:  ${data.Comment || ""}`,
                //     style: "titulo",
                //     colSpan: 5,
                //   },
                //   {}, {}, {}, {},
                // ],
                [
                  

                  { text: "" },

                  [
                    autorizoFinanzas
                      ? {
                        image: "data:image/png;base64," + autorizoFinanzas,
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      }
                      : {
                        image: "data:image/png;base64," + imgBlanca,
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      },
                    {
                      border: [false, true, false, false],
                      text:
                        `\n  _______________________________________ \n${getLabel(
                          RequisasComprasReporteLang,
                          "Finanzas",
                          Language
                        )}` +
                        "\n" +
                        UserNameAutorizoFinanzas,
                      style: "firmas",
                      width: [120],
                    },
                  ],

                  { text: "" },

                  [
                    autorizoPlantaM
                      ? {
                        image: firmaPlantaPDF || firmaBlancaPDF,
                        width: 150,
                        height: 130,

                        margin: [0, 0, -50, -30],
                      }
                      : {
                        image: "data:image/png;base64," + imgBlanca,
                        width: 150,
                        height: 130,
                        margin: [0, 0, -50, -30],
                      },
                    {
                      border: [false, true, false, false],
                      text:
                        `\n  _______________________________________ \n${getLabel(
                          RequisasComprasReporteLang,
                          "GerentePlanta",
                          Language
                        )}` +
                        "\n" +
                        // listadoDetalles[0]?.UserNameAutorizoPlantManager || "",
                        UserNameautorizoPlantManager,
                      style: "firmas",
                      width: [120],
                    },
                  ],

                  { text: "" },

                ],
              ],
            },
            layout: {
              defaultBorder: false,
            },
          },
        ],
      }
    );

    if(notOpen){
      pdfMake.createPdf(docDefinition).open({}, window);
    }else{
        pdfMake.createPdf(docDefinition).getBuffer((buffer) => {
        setBuf(buffer);
        GenerarBufferPDF(buffer)
      });
    }
  };
};

export default RequisasComprasReporte;
